import { render } from "./DistributorList.vue?vue&type=template&id=48d1dd64&scoped=true"
import script from "./DistributorList.vue?vue&type=script&lang=js"
export * from "./DistributorList.vue?vue&type=script&lang=js"

import "./DistributorList.vue?vue&type=style&index=0&id=48d1dd64&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48d1dd64"

export default script